<template>
  <div class="footer-nav">
    <div class="nav-left">
      <img :src="require('@/assets/img/footer/logo.png')" alt="">
    </div>

    <div class="nav-right">
      <div class="nav-right-links">
        <p class="font-weight-bold mb-2">聯絡我們</p>
        <ul>
          <li>
            <router-link
                :to="{ name: 'About' }"
            >
              關於守寫字
            </router-link>
          </li>
          <li>
            <a href="#" target="_blank"><b-icon icon="instagram"></b-icon> writes_tw</a>
          </li>
          <li>
            <a href="#" target="_blank"><b-icon icon="facebook"></b-icon> 手寫字＆守寫字</a>
          </li>
        </ul>
      </div>

      <div class="nav-right-links">
        <p class="font-weight-bold mb-2">線上製作手寫字體</p>
        <ul>
          <li>
            <a href="#">登入</a>
          </li>
          <li>
            <a href="#">製作手寫字體</a>
          </li>
          <li>
            <a href="#">說明中心</a>
          </li>
        </ul>
      </div>

      <div class="nav-right-links">
        <p class="font-weight-bold mb-2">實體產品</p>
        <ul>
          <li>
            <a href="#">讀曆書店</a>
          </li>
          <li>
            <a href="#">我寫的這一年</a>
          </li>
          <li>
            <a href="#">你的字</a>
          </li>
        </ul>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: 'FooterNav',
  data() {
    return {
      
    };
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/main.scss";
.footer-nav {
  display: flex;
  justify-content: space-between;

  letter-spacing: .2em;
  .nav-left {
    margin-bottom: 3rem;
    p {
      text-align: left;
      margin-bottom: .2rem;
    }
    img {
      width: 150px;
    }
  }

  ul, li {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .nav-right {
    display: flex;
    column-gap: 4rem;
  }

  .nav-right-links {
    margin-bottom: 3rem;
    li {
      text-align: left;
      margin-bottom: .5rem;  
      a {
        color: var(--main-dark);
      }
    }
  }


  @include smaller-than-medium() {
    display: block;
    .nav-left {
      text-align: center;
    }

    .nav-right {
      display: block;
      .nav-right-links {
        li, p {
          text-align: center;
        }
      }

    }
  }
}
</style>